(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Best-selling"] && !window.DesignMode) return;
  try {
    
      var productsToShow = 4;
      var totalProducts = 20;
      jQuery(".infinite-scrolling-homepage a").click(function() {
        if (jQuery('.best-selling .grid__item:hidden').length > 0) {                    
          jQuery('.best-selling .grid__item:hidden:lt('+productsToShow+')').each(function() {
              jQuery(this).show();
            jQuery(this).find('img').css('height','auto');     
          });        

          jQuery("window" ).scroll();
          if (jQuery('.best-selling .grid__item:hidden').length == 0) {
            var noMoreText = "No more product";              
              
              jQuery(".best_selling_section .infinite-scrolling-homepage a").text(noMoreText).addClass('disabled');              
            
          }
        }
      });
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
      $(this).text("+");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
      $(this).text("-");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-promoimage"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
     $("#promo-carousel").owlCarousel({ 
      autoPlay: 3000, //Set AutoPlay to 3 seconds 
      items : 1,
      iitemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: true,
		animation: "fade",
        pagination: true
 
  });
});
      

  } catch(e) { console.error(e); }
})();
})();
